<template>
    <div class="lang">
        <div class="popup3">
            <div class="popup__wrap">
                <button type="button" class="close"><img src="/resource/icon/close-white.svg" alt=""></button>
                <div class="popup__inner">
                    <div class="cont">
                        <div class="img">
                            <img src="/resource/img/map-popup.jpg" alt="">
                        </div>
                    </div>
                    <button type="button" class="main-button c-main pc-none ">닫기</button>
                </div>
            </div>
        </div>
        <div class="map">
            <div class="map__box">
            <!-- <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.9040544340555!2d126.83368877629648!3d37.557324224655495!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357c9d53d5ae7753%3A0xab7eac01f7498519!2z7J2064yA7ISc7Jq467OR7JuQ!5e0!3m2!1sko!2skr&hl=en!4v1729663845410!5m2!1sko!2skr"
        class="map__iframe" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe> -->
    <iframe src="https://www.google.com/maps/embed?pb=!1m23!1m12!1m3!1d3162.89819678921!2d126.83364497629664!3d37.55746222464778!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!4m8!3e6!4m0!4m5!1s0x357c9d53d5ae7753%3A0xab7eac01f7498519!2z7J2064yA7ISc7Jq467OR7JuQLCAyNjAgR29uZ2hhbmctZGFlcm8sIEdhbmdzZW8tZ3UsIFNlb3Vs!3m2!1d37.55732!2d126.83626369999999!5e0!3m2!1sen!2skr!4v1734414914990!5m2!1sen!2skr" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" class="map__iframe"></iframe>
                <div class="map__info">
                    <div class="map__address">
                        <h4 class="map__address-tit">地址</h4>
                        <ul class="map__address-list">
                            <li class="map__address-item">
                                <span>门牌号</span>
                                <p>梨花女子大学首尔医院C栋3楼健康促进中心路，首尔江西区麻谷洞808</p>
                            </li>
                            <li class="map__address-item">
                                <span>路名</span>
                                <p>梨花女子大学首尔医院3号楼3楼，首尔江西区空港大道260号</p>
                            </li>
                        </ul>
                    </div>
                    <div class="map__btn">
                        <ul class="map__btn-list">
                            <li class="map__btn-item">
                                <a href="https://naver.me/x7nUngle" target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/naver-map-icon.png" alt=""></span>Naver Map</a>
                            </li>
                            <li class="map__btn-item">
                                <a href="https://kko.kakao.com/LZt68tdGtF" target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/kakao-map-icon.png" alt=""></span>Kakao Map</a>
                            </li>
                            <li class="map__btn-item">
                                <a href="https://maps.app.goo.gl/zw5QLy5U5hcae6ex9"
                                    target="_blank" title="새창이동"><span class="icon"><img src="/resource/icon/google-map-icon.png" alt=""></span>Google Map</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>


            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/bus.svg" alt=""></span>乘穿梭巴士</h4>
            <p class="map__desc">梨花女子大学木洞医院 ↔ 梨花女子大学首尔医院环路</p>
            <div class="map__cont">
                <!-- <img src="/resource/img/map.png" alt=""> -->
                <div class="map__bus">
                    <div class="map__bus-inner">
                        <div class="box">
                            <ul class="map__text">
                                <li class="top">新木洞站(3号出口)</li>
                                <li class="right" style="word-break: break-all;">梨花女子大学首尔医院</li>
                                <li class="bottom">新木洞站(2号出口)</li>
                                <li class="left">梨花女子 大学木洞医院</li>
                            </ul>
                            <div class="map__arrow">
                                <span v-for="i in 4" class="arrow"><img src="/resource/icon/arrow.svg" class="icon" alt=""></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table">
                    <table>
                        <colgroup>
                            <col style="width:20%;">
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>类别分类</th>
                                <th>梨花女子大学木洞医院</th>
                                <th>梨花女子大学首尔医院</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>首班车</td>
                                <td>07:00</td>
                                <td>07:00</td>
                            </tr>
                            <tr>
                                <td><b>末班车</b></td>
                                <td>17:30</td>
                                <td>17:30</td>
                            </tr>
                        </tbody>
                    </table>
                    <p class="table-info">- 请根据时间段参考运行时间表(公交车时刻表可能由于路况/交通情况略有改变)</p>
                    <div class="botton-wrap">
                        <a href="javascript:;" class="main-button c-main">穿梭公交车时刻表</a>
                    </div>
                </div>
            </div>

            <div class="line"></div>

            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/subway.svg" alt=""></span>乘坐地铁</h4>
            <div class="map__cont">
                <div class="map__route mo">
                    <div>
                        <span class="name puple nowrap">5号线</span>
                        <!-- <em class="pc-none">Balsan Station</em> -->
                    </div>
                    <p>从钵山站7或8号出口</p>
                </div>
                <div class="map__route mo">
                    <div>
                        <span class="name yellow nowrap">9号线</span>
                        <!-- <em class="pc-none">Yangcheon Hyanggyo Station, Deungchon Station</em> -->
                    </div>
                    <p>阳川乡校站8号出口(9号线) → 阳川小学.在庆正馆站乘江西06路公交车 → 在钵山站7号出口下车
在登村站1号出口下车 → 在登村中学乘654、661、605、60-3路公交车，或在白石站小学站乘或88路公交车 → 在钵山站（5号线）下车</p>
                </div>
            </div>

            <div class="line"></div>

            <h4 class="map__tit"><span class="icon"><img src="/resource/icon/subway.svg" alt=""></span>乘坐公交车</h4>
            <ul class="map__list map__cont">
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">江西穿梭巴士</span>
                        <p>江西 06</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">普通公交车</span>
                        <p>60, 60-3, 69, 88, 1002</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name green">绿色公交车</span>
                        <p>6629, 6630, 6632, 6645, 6648, 6712</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name blue">蓝色公交车</span>
                        <p>601, 605, 654, N26, N65</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name sky">机场巴士</span>
                        <p>6000(金浦国际机场), 6003(仁川国际机场), 6008</p>
                    </div>
                </li>
                <li class="map__item">
                    <div class="map__route">
                        <span class="name orange">特快巴士</span>
                        <p>3000, 8000</p>
                    </div>
                </li>
            </ul>



        </div>
    </div>
</template>
<script>
    export default {

        mounted() {
            document.querySelector(".map .main-button").addEventListener("click", () => {
                document.querySelector(".popup3").classList.add("active")
            })

            document.querySelector(".popup3 .close").addEventListener("click", () => {
                document.querySelector(".popup3").classList.remove("active")
            })

            document.querySelector(".popup3 .main-button").addEventListener("click", () => {
                document.querySelector(".popup3").classList.remove("active")
            })
        },
    }

</script>
<style>

</style>